import React, { useEffect, useState } from 'react'
import {
  Box,
  Card,
  Container,
  Grid,
  Pagination,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { apiTenant } from '../../../services/Tenant/ApiTenant'
import TenantStatusBadge from '../../../components/Tenant/TenantStatusBadge'
import Lottie from 'lottie-react'
import emptyBox from '../../../assets/animations/emptyBox.json'
import { grey } from '@mui/material/colors'
import moment from 'moment'

const formatBRL = (centavos) => {
  return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

const TenantChargeList = () => {
  const navigate = useNavigate()
  const [charges, setCharges] = useState([])
  const [loading, setLoading] = useState(true)
  const [statusFilter, setStatusFilter] = useState('')

  const toArray = (data) => {
    if (Array.isArray(data)) return data
    if (data?.results && Array.isArray(data.results)) return data.results
    return []
  }

  useEffect(() => {
    setLoading(true)
    apiTenant.get('/tenant/charges/')
      .then(response => {
        setCharges(toArray(response.data))
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const filteredCharges = charges.filter(charge => {
    if (!statusFilter) return true
    return charge.status === statusFilter
  })

  return (
    <>
      <Helmet>
        <title>Cobranças - Portal do Cliente</title>
      </Helmet>
      <Container maxWidth={false}>
        <Box sx={{ marginY: '1em', pb: 1, display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h5">Cobranças</Typography>
        </Box>

        <Card>
          <Grid container sx={{ p: 2, alignItems: 'center' }} spacing={2}>
            <Grid item xs={12} sm={6} lg={4}>
              <ToggleButtonGroup
                fullWidth
                exclusive
                value={statusFilter}
                color="primary"
                onChange={(e, value) => value !== null && setStatusFilter(value)}
                size="small"
              >
                <ToggleButton value="">Todas</ToggleButton>
                <ToggleButton value="pending">Pendentes</ToggleButton>
                <ToggleButton value="overdue">Atrasadas</ToggleButton>
                <ToggleButton value="paid">Pagas</ToggleButton>
              </ToggleButtonGroup>
            </Grid>
          </Grid>

          {loading ? (
            <Skeleton variant="rounded" height={400} animation="pulse" sx={{ margin: 1 }}/>
          ) : filteredCharges.length > 0 ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ color: 'primary.main' }}>Nº</TableCell>
                    <TableCell sx={{ color: 'primary.main' }}>Descrição</TableCell>
                    <TableCell sx={{ color: 'primary.main' }}>Imóvel</TableCell>
                    <TableCell align="center" sx={{ color: 'primary.main' }}>Vencimento</TableCell>
                    <TableCell align="center" sx={{ color: 'primary.main' }}>Status</TableCell>
                    <TableCell sx={{ color: 'primary.main' }}>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredCharges.map(charge => (
                    <TableRow
                      key={charge.id}
                      hover
                      sx={{ cursor: 'pointer' }}
                      onClick={() => navigate(`/area-cliente/cobrancas/${charge.id}`)}
                    >
                      <TableCell>{charge.number}</TableCell>
                      <TableCell>{charge.description}</TableCell>
                      <TableCell>Unidade {charge.unit_number}</TableCell>
                      <TableCell align="center">
                        {charge.due_date ? moment(charge.due_date).format('DD/MM/YYYY') : '-'}
                      </TableCell>
                      <TableCell align="center">
                        <TenantStatusBadge status={charge.status}/>
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>
                        {formatBRL(charge.total)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', py: 4 }}>
              <Typography
                align="center"
                sx={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '24px', fontWeight: 'bold', color: grey[400] }}
              >
                Nenhum Resultado!
              </Typography>
              <Box sx={{ width: '250px' }}>
                <Lottie animationData={emptyBox} loop={true}/>
              </Box>
            </Box>
          )}
        </Card>
      </Container>
    </>
  )
}

export default TenantChargeList
